import { useAuthenticatedUser } from '@ifixit/auth-sdk/client';

export function useCartKeys() {
   const { data: user } = useAuthenticatedUser();
   return {
      mutationKey: ['shopify-cart-mutation', user?.id ?? null],
      queryKey: ['shopify-cart-query', user?.id ?? null],
   };
}
